export default __webpack_public_path__ + "static/media/comment.54af2767.svg";